import { BOOKING_DATE_SEL, BOOKING_TIME_SEL, BOOKING_STATS_SEL } from 'actions/booking';

function booking(state = {}, action) {
  const { payload } = action;

  switch (action.type) {
    case `${BOOKING_DATE_SEL}_FULFILLED`:
      return {
        ...state,
        bookingDateSel: payload
      };

    case `${BOOKING_DATE_SEL}_PENDING`:
      return {
        ...state,
        bookingDateSel: payload
      };

    case `${BOOKING_DATE_SEL}_REJECTED`:
      return {
        ...state,
        bookingDateSel: payload
      };

    case `${BOOKING_TIME_SEL}_FULFILLED`:
      return {
        ...state,
        bookingTimeSel: payload
      };

    case `${BOOKING_TIME_SEL}_PENDING`:
      return {
        ...state,
        bookingTimeSel: payload
      };

    case `${BOOKING_TIME_SEL}_REJECTED`:
      return {
        ...state,
        bookingTimeSel: payload
      };

    case `${BOOKING_STATS_SEL}_FULFILLED`:
      return {
        ...state,
        bookingStatsSel: payload
      };

    case `${BOOKING_STATS_SEL}_PENDING`:
      return {
        ...state,
        bookingStatsSel: payload
      };

    case `${BOOKING_STATS_SEL}_REJECTED`:
      return {
        ...state,
        bookingStatsSel: payload
      };

    default:
      return state;
  }
}

export default booking;
